/**
 * Compute a human-readable dwell time string from a check-in timestamp.
 * Returns "—" if the input is falsy.
 *
 * Examples: "23m", "4h 12m", "2d 6h", "12d"
 */
export function formatDwellTime(occurredAt: string | null | undefined): string {
  if (!occurredAt) return "—";

  const diffMs = Date.now() - new Date(occurredAt).getTime();
  if (diffMs < 0) return "—";

  const totalMinutes = Math.floor(diffMs / 60_000);
  const totalHours = Math.floor(totalMinutes / 60);
  const totalDays = Math.floor(totalHours / 24);

  if (totalDays > 7) return `${totalDays}d`;
  if (totalDays >= 1) {
    const remainingHours = totalHours % 24;
    return remainingHours > 0 ? `${totalDays}d ${remainingHours}h` : `${totalDays}d`;
  }
  if (totalHours >= 1) {
    const remainingMinutes = totalMinutes % 60;
    return remainingMinutes > 0 ? `${totalHours}h ${remainingMinutes}m` : `${totalHours}h`;
  }
  return `${totalMinutes}m`;
}

/**
 * Returns true if the dwell time exceeds 24 hours.
 */
export function isDwellOverThreshold(occurredAt: string | null | undefined, thresholdHours = 24): boolean {
  if (!occurredAt) return false;
  const diffMs = Date.now() - new Date(occurredAt).getTime();
  return diffMs >= thresholdHours * 60 * 60_000;
}
